import { BuyerCommentThreadOverview } from '@/types';

export type CommentThreadReducer = BuyerCommentThreadOverview[];

const initialState: CommentThreadReducer = [];

const commentThreads = (state = initialState, action) => {
    switch (action.type) {
        case 'BUYER_SET_COMMENT_THREADS':
            return action.data;
        default:
            return state;
    }
};

export default commentThreads;